import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'

import { PromotionComponent } from './promotion.component'
import { PlanComponent } from './plan/plan.component'
import { ApplicationComponent } from './application/application.component'
import { LayoutPromotionComponent } from './layout-promotion/layout-promotion.component'
import { CampaignComponent } from './campaign/campaign.component'
import { TutorialComponent } from './tutorial/tutorial.component'
import { FaqComponent } from './faq/faq.component'
import { ContactComponent } from './contact/contact.component'
import { CompanyComponent } from './company/company.component'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component'
import { ResetPasswordComponent } from './reset-password/reset-password.component'


const routes: Routes = [
    {
        path: '', component: LayoutPromotionComponent,
        children: [
            { path: '', component: PromotionComponent, pathMatch: 'full' },
            { path: 'top', component: PromotionComponent },
            { path: 'plan', component: PlanComponent },
            { path: 'application', component: ApplicationComponent },
            { path: 'campaign', component: CampaignComponent },
            { path: 'tutorial', component: TutorialComponent },
            { path: 'faq', component: FaqComponent },
            { path: 'contact', component: ContactComponent },
            { path: 'company', component: CompanyComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: 'reset-password/:token', component: ResetPasswordComponent },
            // {path: '**', component: PromotionComponent},
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class PromotionRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/promotion/promotion.routing.ts